import React from 'react';
import Button from '../../elements/CustomButton/CustomButton.jsx';

function AssignSelectPanel(props) {
  return (
    <div>
      <div style={{ paddingBottom: 5 }} className="visible-xs-block">
        <Button bsStyle="info" bsSize="small" fill wd block onClick={props.onClickAssign} disabled={props.assignDisabled}>
          Asignar Tutor
        </Button>
        <span style={{ display:"block", height:"10px"}}>  </span>
        <Button bsStyle="primary" bsSize="small" fill wd block onClick={props.onClickSelect} disabled={props.selectDisabled}>
          {props.selectButtonLabel}
        </Button>
        <span style={{ display:"block", height:"10px"}}>  </span>
        <Button bsStyle="danger" bsSize="small" fill wd block onClick={props.onClickArchive} disabled={props.selectDisabled}>
          {props.archiveButtonLabel}
        </Button>
      </div>
      <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
        <Button bsStyle="info" bsSize="small" fill wd onClick={props.onClickAssign} disabled={props.assignDisabled}>
          Asignar Tutor
        </Button>
        <span>  </span>
        <Button bsStyle="primary" bsSize="small" fill wd onClick={props.onClickSelect} disabled={props.selectDisabled}>
          {props.selectButtonLabel}
        </Button>
        <span>  </span>
      </div>
    </div>
  );
}

export default AssignSelectPanel;



// WEBPACK FOOTER //
// ./src/views/Components/AssignSelectPanel.jsx